import {
  AsyncDataPreset,
  AsyncDataTransformer,
  useAsyncData,
} from '../../../../../api/asyncData';
import { CategoryParent } from '../../../../../constants';
import { CountryOption } from '../../types/CountryOption';

export const usePhoneCountries = () => {
  const { data: countries, isLoading } = useAsyncData({
    preset: AsyncDataPreset.Categories,
    parent: CategoryParent.CountryMobileCodes,
    transformer: AsyncDataTransformer.Options,
  });

  const defaultCountry = (countries as CountryOption[])[0];

  return {
    countries: countries as CountryOption[],
    defaultCountry,
    isLoading,
  };
};
